module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-loading-spinner",
    class: {
      'is-full-screen': _vm.fullScreen
    }
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })]), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "zk-loading-text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-7170b320"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/loading/src/spinner.vue
// module id = 268
// module chunks = 0